/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NoMeetingDayOfWeek = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type TeamSettingsAdminNoMeetingDay_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly teamSettings: {
        readonly __typename: "TeamSettings";
        readonly manageTeamCalendar: boolean;
        readonly useNoMeetingDay: boolean;
        readonly noMeetingDayOfWeek: NoMeetingDayOfWeek;
        readonly noMeetingDayEmailOnScheduleOver: boolean;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "TeamSettingsAdminNoMeetingDay_org";
};
export type TeamSettingsAdminNoMeetingDay_org$data = TeamSettingsAdminNoMeetingDay_org;
export type TeamSettingsAdminNoMeetingDay_org$key = {
    readonly " $data"?: TeamSettingsAdminNoMeetingDay_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsAdminNoMeetingDay_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "teamId"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsAdminNoMeetingDay_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "experiments",
            "storageKey": null
        },
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "teamId",
                    "variableName": "teamId"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "teamSettings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manageTeamCalendar",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "useNoMeetingDay",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "noMeetingDayOfWeek",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "noMeetingDayEmailOnScheduleOver",
                            "storageKey": null
                        }
                    ],
                    "type": "TeamSettings",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '6ce3ad8cf932577c73d040dae53e4074';
export default node;
